import Vue from 'vue';
import Vuex from 'vuex';
import LocalstorageStore from './localstorage.store.plugin';

// #region modules
import AuthModule from './modules/auth.store';
// #endregion modules

const storeUserPlugin = LocalstorageStore.create(
  'auth/setUser',
  process.env.VUE_APP_AUTH_USER_DETAILS,
  state => state.auth.user,
);
const storeTokenPlugin = LocalstorageStore.create(
  'auth/setToken',
  process.env.VUE_APP_AUTH_TOKEN_KEY,
  state => state.auth.token,
);

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [storeUserPlugin, storeTokenPlugin],
  modules: {
    auth: AuthModule,
  },
});
